import { cn } from "@/utils/utils";
import { ReactNode } from "react";

interface FormFieldProps {
  label: string;
  id: string;
  name: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  placeholder?: string;
  type?: string;
  className?: string;
  children?: ReactNode;
  disabled?: boolean;
}

const FormField = ({
  label,
  id,
  name,
  value,
  onChange,
  error,
  placeholder,
  type = "text",
  className,
  children,
  disabled = false,
}: FormFieldProps) => {
  const baseInputClassName =
    "placeholder:text-[#94A3B8] text-sm h-12 rounded-lg border border-[#E2E8F0] bg-white px-3 text-[#020617] outline-none placeholder:text-sm placeholder:font-normal";

  return (
    <div className="flex w-full flex-col">
      <label htmlFor={id} className="mb-2 text-sm font-medium text-neutral-800">
        {label}
      </label>
      {children || (
        <input
          id={id}
          type={type}
          name={name}
          placeholder={placeholder}
          className={cn(baseInputClassName, className)}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      )}
      {error && <p className="mx-1 mt-1 text-[13px] text-red-500">{error}</p>}
    </div>
  );
};

export default FormField;
